import React from "react";
import { Button, CircularProgress } from "@mui/material";

const CakeImageUploader = ({ uploading, file, url, onFileChange }) => (
  <>
    <Button
      variant="contained"
      component="label"
      fullWidth
      sx={{ mt: 2 }}
      disabled={uploading}>
      {uploading ? (
        <CircularProgress size={20} color="inherit" />
      ) : url || file ? (
        "Change Image"
      ) : (
        "Upload Image"
      )}
      <input type="file" hidden onChange={onFileChange} />
    </Button>
    {(file || url) && (
      <img
        src={file ? URL.createObjectURL(file) : url}
        alt="Preview"
        style={{
          width: "100px",
          height: "100px",
          borderRadius: 8,
          marginTop: 10,
        }}
      />
    )}
  </>
);

export default CakeImageUploader;
